import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmationDialogComponent } from '../components/dialogs/confirmation-dialog/confirmation-dialog.component';

@Directive({
  selector: '[optConfirmation]',
})
export class ConfirmationDirective {
  @Input()
  public title: string;

  @Input()
  public body: string;

  @Output()
  public confirmOk: EventEmitter<any> = new EventEmitter();

  @Output()
  public confirmCancel: EventEmitter<any> = new EventEmitter();

  constructor(
    private readonly elementRef: ElementRef,
    private dialog: MatDialog
  ) {}

  @HostListener('click', ['$event.target'])
  public onClick(button): void {
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: this.title,
        body: this.body,
      },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.confirmOk.emit();
      } else {
        this.confirmCancel.emit();
      }
    });
  }
}
